// extracted by mini-css-extract-plugin
module.exports = {"more":"list_more__c1cs1","open":"list_open__gRMDT","item":"list_item__8RNwQ","itemMobile":"list_itemMobile__GYXVZ","count":"list_count__CeF_5"};